import React from 'react';
import { Link } from 'react-router-dom';
var ServerFaultPage = function () {
    return (<div className="server-fault">
      Page not found
      <Link to="/">Вернуться на главную</Link>
    </div>);
};
export default ServerFaultPage;
